import {
  Box,
  Button,
  Flex,
  Spacer,
  Center,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useMemo, useState } from "react";
import navguard from "../auth/navguard";
import "./styles/mass-discount-setup.scss";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import Pagination from "./component/pagination";
import Axios from "../../services/axios";
import { isEmpty } from "lodash";
import dateFormat from "dateformat";
import Breadcrumb from "../common/breadcrumb";
import BulkDiscountModal from "./component/BulkDiscountModal";

const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M16.25 2.75C17.0784 2.75 17.75 3.42158 17.75 4.25V11C17.75 11.4142 17.4142 11.75 17 11.75C16.5858 11.75 16.25 11.4142 16.25 11V4.25H5.75V17.75H11C11.4142 17.75 11.75 18.0858 11.75 18.5C11.75 18.9142 11.4142 19.25 11 19.25H5.75C4.92156 19.25 4.25 18.5784 4.25 17.75V4.25C4.25 3.42157 4.92157 2.75 5.75 2.75H16.25ZM15.3125 12.5C15.5114 12.5 15.7021 12.5791 15.8428 12.7197L17.5303 14.4072L17.5811 14.4648C17.8213 14.7594 17.8048 15.1932 17.5303 15.4678C17.2557 15.7424 16.8209 15.7598 16.5264 15.5195L16.4697 15.4678L16.0625 15.0605V18.5C16.0625 18.9142 15.7267 19.25 15.3125 19.25C14.8983 19.25 14.5625 18.9142 14.5625 18.5V15.0605L14.1553 15.4678C13.8624 15.7607 13.3876 15.7607 13.0947 15.4678C12.8018 15.1749 12.8018 14.7001 13.0947 14.4072L14.7822 12.7197L14.8369 12.6699C14.9704 12.5605 15.1384 12.5 15.3125 12.5ZM11 10.25C11.4142 10.25 11.75 10.5858 11.75 11C11.75 11.4142 11.4142 11.75 11 11.75H8C7.58579 11.75 7.25 11.4142 7.25 11C7.25 10.5858 7.58579 10.25 8 10.25H11ZM14 7.25C14.4142 7.25 14.75 7.58579 14.75 8C14.75 8.41421 14.4142 8.75 14 8.75H8C7.58579 8.75 7.25 8.41421 7.25 8C7.25 7.58579 7.58579 7.25 8 7.25H14Z"
      fill="#2A3D4A"
    />
  </svg>
);

const limit = 10;

const MassDiscountSetup = () => {
  const [page, setPage] = useState(0);
  const [dataTable, setDataTable] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const columns = useMemo(
    () => [
      {
        dataField: "createdAt",
        text: "No",
        formatter: (_cell, _row, index) => (
          <p style={{ color: "black" }}>{page * limit + index + 1}</p>
        ),
      },
      {
        dataField: "email",
        text: "User Email",
        sort: true,
      },
      {
        dataField: "originalName",
        text: "Nama File",
        sort: true,
      },
      {
        dataField: "createdAt",
        text: "Tanggal",
        sort: true,
        formatter: (cell) => (
          <p style={{ color: "black" }}>{dateFormat(cell, "dd/mm/yyyy")}</p>
        ),
      },
      {
        dataField: "result",
        text: "Total Baris Error",
        sort: true,
        formatter: (cell) => (
          <p style={{ color: "black" }}>{cell?.failed?.length ?? "-"}</p>
        ),
      },
      {
        dataField: "result",
        text: "Total Baris Success",
        sort: true,
        formatter: (cell) => (
          <p style={{ color: "black" }}>{cell?.successCount ?? "-"}</p>
        ),
      },
    ],
    [page, limit]
  );

  const changePageHandler = (value) => {
    setPage(value.selected);
  };

  const fetchData = async () => {
    try {
      const { data } = await Axios({
        url: "/product/discount/bulk-history",
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
        params: {
          page: page + 1,
          limit,
        },
      });
      setTotalPage(data.data.totalPage);
      setDataTable(data.data.histories);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, [page]);

  return (
    <Box className="mass-discount-setup__container">
      <Breadcrumb title="Mass Discount Setup" parent="Product" isStack />
      <Spacer />
      <Flex justifyContent="flex-end" alignItems="center" mb={3} gap="24px">
        <Button className="mass-discount-setup__button" onClick={onOpen}>
          <UploadIcon />
          Bulk Update
        </Button>
      </Flex>

      {!isEmpty(dataTable) && (
        <ToolkitProvider
          data={dataTable}
          columns={columns}
          keyField="createdAt"
        >
          {(props) => (
            <div className="py-4 table-responsive mass-discount-setup__table-container">
              <BootstrapTable
                {...props.baseProps}
                bootstrap4={true}
                bordered={false}
                trStyle={{ backgroundColor: "white" }}
                noDataIndication={"There is no data entry"}
              />
            </div>
          )}
        </ToolkitProvider>
      )}

      {totalPage ? (
        <Box mt="1em">
          <Pagination
            page={page}
            totalPage={totalPage}
            changePageHandler={changePageHandler}
          />
        </Box>
      ) : (
        <Center>There is no data entry</Center>
      )}
      <BulkDiscountModal
        isOpen={isOpen}
        onClose={onClose}
        refetchTable={fetchData}
      />
    </Box>
  );
};

export default navguard(MassDiscountSetup);
